if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        languageCode: this.querySelector('input[name="language_code"]'),
        countryCode: this.querySelector('input[name="country_code"]'),
        button: this.querySelector('[data-toggle-disclosure]'),
        panel: this.querySelector('[data-disclosure-panel]'),
        items: this.querySelectorAll('.language-disclosure__item a'),
      };

      this.elements.button.addEventListener('click', this.togglePanel.bind(this));
      document.addEventListener('click', this.outsideClickListener.bind(this));

      this.elements.items.forEach((item) => {
        item.addEventListener('click', this.onItemClick.bind(this));
      });
    }

    togglePanel() {
      const expanded = this.elements.button.getAttribute('aria-expanded') === 'true';
      this.elements.button.setAttribute('aria-expanded', (!expanded).toString());
      this.elements.panel.classList.toggle('hidden', expanded);
    }

    outsideClickListener(event) {
      if (
        !this.contains(event.target) &&
        this.elements.panel &&
        !this.elements.panel.classList.contains('hidden')
      ) {
        this.elements.panel.classList.add('hidden');
        this.elements.button.setAttribute('aria-expanded', 'false');
      }
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');

      if (!form) return;

      const language = event.currentTarget.dataset.language;
      const country = event.currentTarget.dataset.country;

      if (language) this.elements.languageCode.value = language;
      if (country) this.elements.countryCode.value = country;

      form.submit();
    }
  }

  customElements.define('localization-form', LocalizationForm);
}
